import Fragments from "react-shared/api/Fragments";

const writeFragment = ({model, data, client}) =>
  console.log(model, data) ||
  client.writeFragment({id: `${data.model}:${data.id}`, fragment: Fragments[model].public, data, fragmentName: `${model}Public`})

export default writeFragment;